export function getWrappedIndex(index: number, total: number): number {
  const wrappedIndex = index % total
  if (wrappedIndex < 0) {
    return wrappedIndex + total
  }

  return wrappedIndex
}
